import { render, staticRenderFns } from "./SamplingLocation.vue?vue&type=template&id=27fd3195"
import script from "./SamplingLocation.vue?vue&type=script&lang=js"
export * from "./SamplingLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports